export default [
  //*** LOGIN ***/
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      guest: false
    }
  },

    //*** Reset Password ***/
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: () => import('../views/ResetPassword.vue'),
      meta: {
        guest: false
      }
    },

  //*** ADMIN  ***//
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin/AdminPanel.vue'),
    meta: {
      auth: true,
      admin: true
    }
  },

   /*** ACCOUNTS  ***/
   {
    path: '/accounts/:parentBAN',
    name: 'accounts',
    component: () => import('../views/Accounts/Accounts.vue'),
    meta: {
      auth: true
    }
  },

   /*** Search  ***/
   {
    path: '/search',
    name: 'search',
    component: () => import('../views/Search/Search.vue'),
    meta: {
      auth: true
    }
  },

   /*** Reports  ***/
   {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/Reports/Reports.vue'),
    meta: {
      auth: true
    }
  },

   /*** Receivables  ***/
   {
    path: '/receivables/:BAN',
    name: 'receivables',
    component: () => import('../views/Receivables/Receivables.vue'),
    meta: {
      auth: true
    }
  },

   /*** Services  ***/
   {
    path: '/services/:BAN',
    name: 'services',
    component: () => import('../views/Services/Services.vue'),
    meta: {
      auth: true
    }
  },

   /*** Charges  ***/
   {
    path: '/charges/:BAN',
    name: 'charges',
    component: () => import('../views/Charges/Charges.vue'),
    meta: {
      auth: true
    }
  },

   /*** Rate Plan Maintenance  ***/
   {
    path: '/rate-plan-maintenance',
    name: 'rate-plan-maintenance',
    component: () => import('../views/RatePlanMaintenance/RatePlanMaintenance.vue'),
    meta: {
      auth: true
    }
  },

   /*** Mediation  ***/
   {
    path: '/mediation',
    name: 'mediation',
    component: () => import('../views/Mediation/Mediation.vue'),
    meta: {
      auth: true
    }
  },

   /*** Rating  ***/
   {
    path: '/rating',
    name: 'rating',
    component: () => import('../views/Rating/Rating.vue'),
    meta: {
      auth: true
    }
  },

   /*** Billing  ***/
   {
    path: '/billing',
    name: 'billing',
    component: () => import('../views/Billing/Billing.vue'),
    meta: {
      auth: true
    }
  },

   /*** Publishing  ***/
   {
    path: '/publishing',
    name: 'publishing',
    component: () => import('../views/Publishing/Publishing.vue'),
    meta: {
      auth: true
    }
  },

   /*** My Account  ***/
   {
    path: '/my-account',
    name: 'my-account',
    component: () => import('../views/MyAccount/MyAccount.vue'),
    meta: {
      auth: true
    }
  },

   /*** Account Summary  ***/
   {
    path: '/account-summary/:BAN',
    name: 'account-summary',
    component: () => import('../views/Accounts/AccountSummary.vue'),
    meta: {
      auth: true
    }
  },
  /*** Log  ***/
  {
    path: '/log/:Type/:BAN/:ServiceId/:ChargeId',
    name: 'log',
    component: () => import('../views/Log/Log.vue'),
    meta: {
      auth: true
    }
  },
  /*** Tickets  ***/
  {
    path: '/tickets/:BAN',
    name: 'tickets',
    component: () => import('../views/Tickets/Tickets.vue'),
    meta: {
      auth: true
    }
  },
    /*** Report History  ***/
    {
      path: '/report-history/:ReportId',
      name: 'report history',
      component: () => import('../views/Reports/ReportHistory.vue'),
      meta: {
        auth: true
      }
    },
    /*** Report View  ***/
    {
      path: '/report-view/:ReportId/:ReportInstanceId',
      name: 'report view',
      component: () => import('../views/Reports/ReportView.vue'),
      meta: {
        auth: true
      }
    },
     /*** Receivables  ***/
   {
    path: '/active-batches/:newBatch?',
    name: 'active batches',
    component: () => import('../views/Receivables/ActiveBatches.vue'),
    meta: {
      auth: true
    }
  },
    /*** Receivables  ***/
    {
      path: '/posting-history/',
      name: 'posting history',
      component: () => import('../views/Receivables/PostingHistory.vue'),
      meta: {
        auth: true
      }
    },
    /*** Dashboard  ***/
    {
      path: '/dashboards/',
      name: 'dashboards',
      component: () => import('../views/Dashboard/Dashboards.vue'),
      meta: {
        auth: true
      }
    },
    /*** Dashboard  ***/
    {
      path: '/dashboard-view/:DBID',
      name: 'dashboard view',
      component: () => import('../views/Dashboard/DashboardView.vue'),
      meta: {
        auth: true
      }
    },
    /*** Dashboard  ***/
    {
      path: '/my-dashboards/',
      name: 'my dashboards',
      component: () => import('../views/Dashboard/MyDashboards.vue'),
      meta: {
        auth: true
      }
    },
  

  /*** REDIRECT  ***/
  {
    path: '/',
    redirect: '/search'
  },
  {
    path: '/*',
    redirect: '/search'
  }
]
